export default __webpack_public_path__ + "static/media/swissKnife.6c41ee0a.svg";